import {createApp} from 'vue';
import { createPinia } from 'pinia'
import BookingWizard from './vue/modules/optima/BookingWizard.vue';
import WebShop from './vue/modules/shop/Webshop.vue';

// Ensure namespace exists
window.TABS = window.TABS || {};

window.TABS.optimaWizard = {
    init: function () {
        const app = createApp({});
        const pinia = createPinia();
        app.config.globalProperties.$t = TABS.$t;
        app.use(pinia)
        app.component('bookingwizard', BookingWizard)
        app.mount('#optima-wizard');
    }
}

window.TABS.webshop = {
    init: async function () {

        if (!Object.keys(window.TABS.translation.messages).length) {
            await window.TABS.translation.init()
        }
        const el = document.getElementById('webshop');
        if (!el) {
            return;
        }
        // Prevent double-mounting if init is called multiple times
        if (el.getAttribute('data-v-app-mounted') === '1') {
            return;
        }

        const app = createApp({});
        const pinia = createPinia();
        app.config.globalProperties.$t = TABS.$t;
        app.use(pinia)
        app.component('webshop', WebShop)
        app.mount('#webshop');
        el.setAttribute('data-v-app-mounted', '1');
    }
}

// Ensure DOM is ready before checking for and mounting the webshop component
const initWebshopWhenDomReady = () => {
    const start = () => {
        const el = document.getElementById('webshop');
        if (el) {
            window.TABS.webshop.init();
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
};

initWebshopWhenDomReady();
